// import React, { useEffect, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   TextField,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
//   OutlinedInput,
//   Typography,
//   CircularProgress,
//   Box,
//   InputAdornment,
//   Autocomplete,
//   Snackbar,
//   Alert,
//   Grid,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { fetchCandidates, searchCandidates } from "../api";
// import { useAuth } from "../App";
// import { API_URL } from "../config";

// const EVENT_TYPES = [
//   { value: "interview", label: "Interview" },
//   { value: "call", label: "Call" },
//   { value: "meeting", label: "Meeting" },
//   { value: "other", label: "Other" },
// ];

// export default function EventScheduleModalV2({
//   open,
//   onClose,
//   onSubmit,
//   recruiterEmail = "",
// }) {
//   const { fetchWithAuth } = useAuth();
//   const [summary, setSummary] = useState("");
//   const [description, setDescription] = useState("");
//   const [start, setStart] = useState("");
//   const [end, setEnd] = useState("");
//   const [eventType, setEventType] = useState("interview");
//   const [notes, setNotes] = useState("");
//   const [attachment, setAttachment] = useState("");
//   const [error, setError] = useState("");

//   // Candidate & Job selection with pagination and efficient search
//   const [candidates, setCandidates] = useState([]);
//   const [candidatesLoading, setCandidatesLoading] = useState(false);
//   const [candidateId, setCandidateId] = useState("");
//   const [candidateSearchTerm, setCandidateSearchTerm] = useState("");
//   const [candidatePagination, setCandidatePagination] = useState({
//     page: 1,
//     total: 0,
//     pages: 1,
//     hasMore: false,
//   });
//   const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

//   const [jobs, setJobs] = useState([]);
//   const [jobsLoading, setJobsLoading] = useState(false);
//   const [jobId, setJobId] = useState("");
//   const [jobAppMap, setJobAppMap] = useState({});

//   // Reset form when modal opens
//   useEffect(() => {
//     if (open) {
//       setSummary("");
//       setDescription("");
//       setStart("");
//       setEnd("");
//       setEventType("interview");
//       setNotes("");
//       setAttachment("");
//       setError("");
//       setCandidateId("");
//       setJobId("");
//       setJobs([]);
//       setCandidateSearchTerm("");
//       setDebouncedSearchTerm("");
//       setCandidatePagination({
//         page: 1,
//         total: 0,
//         pages: 1,
//         hasMore: false,
//       });
//       // Initial load with empty search
//       loadCandidates("");
//     }
//   }, [open]);

//   // Debounce search term to prevent excessive API calls
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setDebouncedSearchTerm(candidateSearchTerm);
//     }, 300); // 300ms delay

//     return () => clearTimeout(timer);
//   }, [candidateSearchTerm]);

//   // Load candidates when debounced search term changes
//   useEffect(() => {
//     if (open) {
//       loadCandidates(debouncedSearchTerm);
//     }
//   }, [debouncedSearchTerm, open]);

//   // Function to load candidates with search and pagination
//   const loadCandidates = async (search, page = 1) => {
//     setCandidatesLoading(true);
//     try {
//       const result = await searchCandidates(fetchWithAuth, {
//         search,
//         page,
//         limit: 20, // Reasonable page size for dropdown
//       });

//       if (page === 1) {
//         setCandidates(result.data || []);
//       } else {
//         const existingIds = new Set(candidates.map((c) => c.id));
//         const newCandidates = result.data.filter((c) => !existingIds.has(c.id));
//         setCandidates((prev) => [...prev, ...newCandidates]);
//       }

//       setCandidatePagination({
//         page: result.page,
//         total: result.total,
//         pages: result.pages,
//         hasMore: result.page < result.pages,
//       });
//     } catch (error) {
//       console.error("Error loading candidates:", error);
//       if (page === 1) {
//         setCandidates([]);
//       }
//     } finally {
//       setCandidatesLoading(false);
//     }
//   };

//   // Load jobs when candidate changes
//   useEffect(() => {
//     setJobs([]);
//     setJobId("");
//     setJobAppMap({});

//     if (!candidateId) {
//       return;
//     }

//     setJobsLoading(true);

//     const selectedCandidate = candidates.find((c) => c.id === candidateId);
//     const candidateEmail = selectedCandidate ? selectedCandidate.email : null;

//     fetchWithAuth(`${API_URL}/applications/`)
//       .then(async (res) => {
//         if (!res.ok) {
//           return { jobs: [], jobAppMap: {} };
//         }
//         const apps = await res.json();
//         const filteredApps = (apps || []).filter(
//           (app) => app.applicant_email === candidateEmail
//         );

//         const jobAppMap = {};
//         filteredApps.forEach((app) => {
//           if (app.job_order_id) jobAppMap[app.job_order_id] = app.id;
//         });

//         const jobOrderIds = [
//           ...new Set(filteredApps.map((app) => app.job_order_id)),
//         ];
//         if (jobOrderIds.length === 0) return { jobs: [], jobAppMap };

//         const jobOrderPromises = jobOrderIds.map((id) =>
//           fetchWithAuth(`${API_URL}/job-orders/${id}`)
//             .then((r) => (r.ok ? r.json() : null))
//             .catch(() => null)
//         );
//         const jobOrders = (await Promise.all(jobOrderPromises)).filter(Boolean);
//         return { jobs: jobOrders, jobAppMap };
//       })
//       .then(({ jobs, jobAppMap }) => {
//         let flatJobOrders = Array.isArray(jobs) ? jobs.flat() : [];
//         setJobs(flatJobOrders);
//         setJobAppMap(jobAppMap);
//         if (flatJobOrders && flatJobOrders.length === 1) {
//           setJobId(flatJobOrders[0].id);
//         } else if (!flatJobOrders || flatJobOrders.length === 0) {
//           setJobId("");
//         }
//       })
//       .catch(() => {
//         setJobs([]);
//         setJobAppMap({});
//       })
//       .finally(() => setJobsLoading(false));
//   }, [candidateId, fetchWithAuth, candidates]);

//   // Snackbar state
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   // Editable attendees field (optional, not prepopulated)
//   const [attendeesField, setAttendeesField] = useState("");

//   const [scheduling, setScheduling] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMsg, setSnackbarMsg] = useState("");

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") return;
//     setSnackbarOpen(false);
//   };

//   const handleSubmit = async () => {
//     if (!summary || !start || !end || !candidateId || !jobId) {
//       setError("All fields marked as * are required.");
//       return;
//     }
//     const startDate = new Date(start);
//     const endDate = new Date(end);
//     if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
//       setError("Invalid date/time format.");
//       return;
//     }
//     if (startDate >= endDate) {
//       setError("Start time must be before end time.");
//       return;
//     }
//     setError("");
//     setScheduling(true);
//     try {
//       if (onSubmit) {
//         const selectedCandidate = candidates.find((c) => c.id === candidateId);
//         const candidateEmail = selectedCandidate ? selectedCandidate.email : null;
//         const candidateName = selectedCandidate
//           ? selectedCandidate.full_name
//           : "";
//         const selectedJob = jobs.find((j) => j.id === jobId);
//         const jobTitle = selectedJob ? selectedJob.title : "";
//         const attendees = [];
//         if (candidateEmail) attendees.push(candidateEmail);
//         if (recruiterEmail) attendees.push(recruiterEmail);
//         const applicationId = jobAppMap[jobId] || null;
//         const attendeeList = attendeesField
//           .split(",")
//           .map((a) => a.trim())
//           .filter((a) => a.length > 0);
//         const result = await onSubmit({
//           summary,
//           description,
//           start,
//           end,
//           event_type: eventType,
//           notes,
//           attachment,
//           recruiter_email: recruiterEmail,
//           candidate_id: candidateId,
//           job_order_id: jobId,
//           attendees: attendeeList.length > 0 ? attendeeList : [],
//           application_id: applicationId,
//         });
//         setSnackbarMsg(
//           `Interview scheduled for ${candidateName}${
//             jobTitle ? ` (${jobTitle})` : ""
//           }!`
//         );
//         setSnackbarOpen(true);
//         if (typeof onClose === "function") onClose();
//       }
//     } catch (err) {
//       let errorMsg = "Failed to schedule interview. Please try again.";
//       if (err && err.message) {
//         errorMsg = err.message;
//       } else if (typeof err === "string") {
//         errorMsg = err;
//       }
//       setError(errorMsg);
//     } finally {
//       setScheduling(false);
//     }
//   };

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={onClose}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: 3,
//             boxShadow: "0 24px 60px rgba(15,23,42,0.30)",
//           },
//         }}
//       >
//         <DialogTitle sx={{ pb: 1 }}>
//           <Typography variant="h6" fontWeight={700}>
//             Schedule Event
//           </Typography>
//           <Typography
//             variant="body2"
//             color="text.secondary"
//             sx={{ mt: 0.5 }}
//           >
//             Creae an interview, call, or meeting and send calendar invites.
//           </Typography>
//         </DialogTitle>

//         <DialogContent
//           dividers
//           sx={{
//             pt: 2.5,
//             pb: 2.5,
//           }}
//         >
//           {error && (
//             <Typography color="error" variant="body2" sx={{ mb: 2 }}>
//               {error}
//             </Typography>
//           )}

//           <Grid container spacing={2.5}>
//             {/* Candidate */}
//             <Grid item xs={12} md={6}>
//               <Autocomplete
//                 fullWidth
//                 options={candidates}
//                 loading={candidatesLoading}
//                 getOptionLabel={(option) =>
//                   `${option.full_name} (${option.email})`
//                 }
//                 isOptionEqualToValue={(option, value) => option.id === value.id}
//                 value={
//                   candidates.find((c) => c.id === candidateId) || null
//                 }
//                 onChange={(event, newValue) => {
//                   setCandidateId(newValue ? newValue.id : "");
//                 }}
//                 onInputChange={(event, newInputValue) => {
//                   setCandidateSearchTerm(newInputValue);
//                 }}
//                 filterOptions={(x) => x}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label="Recipient (Candidate)*"
//                     required
//                     InputProps={{
//                       ...params.InputProps,
//                       startAdornment: (
//                         <>
//                           <InputAdornment position="start">
//                             <SearchIcon />
//                           </InputAdornment>
//                           {params.InputProps.startAdornment}
//                         </>
//                       ),
//                       endAdornment: (
//                         <>
//                           {candidatesLoading ? (
//                             <CircularProgress color="inherit" size={20} />
//                           ) : null}
//                           {params.InputProps.endAdornment}
//                         </>
//                       ),
//                     }}
//                   />
//                 )}
//                 noOptionsText="No candidates found"
//                 loadingText="Loading candidates..."
//                 ListboxProps={{
//                   onScroll: (event) => {
//                     const listboxNode = event.currentTarget;
//                     if (
//                       candidatePagination.hasMore &&
//                       !candidatesLoading &&
//                       listboxNode.scrollTop + listboxNode.clientHeight >=
//                         listboxNode.scrollHeight - 50
//                     ) {
//                       loadCandidates(
//                         debouncedSearchTerm,
//                         candidatePagination.page + 1
//                       );
//                     }
//                   },
//                 }}
//               />
//             </Grid>

//             {/* Job Order */}
//             <Grid item xs={12} md={6}>
//               <FormControl
//                 fullWidth
//                 required
//                 disabled={!candidateId || jobsLoading}
//               >
//                 <InputLabel id="job-label">Job Order</InputLabel>
//                 <Select
//                   labelId="job-label"
//                   value={jobId || ""}
//                   onChange={(e) => setJobId(e.target.value)}
//                   input={<OutlinedInput label="Job Order" />}
//                   aria-label="Job Order"
//                 >
//                   {jobsLoading ? (
//                     <MenuItem value="">
//                       <CircularProgress size={18} sx={{ mr: 1 }} />
//                       Loading...
//                     </MenuItem>
//                   ) : jobs.length === 0 ? (
//                     <MenuItem value="">
//                       <em>No jobs found for candidate</em>
//                     </MenuItem>
//                   ) : (
//                     jobs.map((j, idx) => (
//                       <MenuItem key={j.id || idx} value={j.id || ""}>
//                         {j.title || `Job ${j.id || idx}`}
//                       </MenuItem>
//                     ))
//                   )}
//                 </Select>
//               </FormControl>
//             </Grid>

//             {/* Summary */}
//             <Grid item xs={12}>
//               <TextField
//                 label="Summary"
//                 fullWidth
//                 value={summary}
//                 onChange={(e) => setSummary(e.target.value)}
//                 required
//               />
//             </Grid>

//             {/* Attendees */}
//             <Grid item xs={12}>
//               <TextField
//                 label="Attendees (comma-separated emails)"
//                 fullWidth
//                 value={attendeesField}
//                 onChange={(e) => setAttendeesField(e.target.value)}
//                 helperText="Optional: add emails to invite additional attendees."
//               />
//             </Grid>

//             {/* Description */}
//             <Grid item xs={12}>
//               <TextField
//                 label="Description"
//                 fullWidth
//                 multiline
//                 minRows={2}
//                 value={description}
//                 onChange={(e) => setDescription(e.target.value)}
//               />
//             </Grid>

//             {/* Start / End */}
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Start Time"
//                 type="datetime-local"
//                 fullWidth
//                 value={start}
//                 onChange={(e) => setStart(e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 required
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="End Time"
//                 type="datetime-local"
//                 fullWidth
//                 value={end}
//                 onChange={(e) => setEnd(e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 required
//               />
//             </Grid>

//             {/* Event type + Attachment */}
//             <Grid item xs={12} md={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Event Type</InputLabel>
//                 <Select
//                   value={eventType}
//                   onChange={(e) => setEventType(e.target.value)}
//                   input={<OutlinedInput label="Event Type" />}
//                 >
//                   {EVENT_TYPES.map((type) => (
//                     <MenuItem key={type.value} value={type.value}>
//                       {type.label}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Attachment (URL)"
//                 fullWidth
//                 value={attachment}
//                 onChange={(e) => setAttachment(e.target.value)}
//               />
//             </Grid>

//             {/* Notes */}
//             <Grid item xs={12}>
//               <TextField
//                 label="Notes"
//                 fullWidth
//                 multiline
//                 minRows={2}
//                 value={notes}
//                 onChange={(e) => setNotes(e.target.value)}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>

//         <DialogActions
//           sx={{
//             px: 3,
//             py: 2,
//             bgcolor: (theme) => theme.palette.grey[50],
//           }}
//         >
//           <Button onClick={onClose} color="inherit">
//             Cancel
//           </Button>
//           <Button
//             onClick={handleSubmit}
//             variant="contained"
//             disabled={candidatesLoading || jobsLoading || scheduling}
//             startIcon={
//               scheduling ? (
//                 <CircularProgress size={18} color="inherit" />
//               ) : null
//             }
//           >
//             {scheduling ? "Scheduling..." : "Schedule"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={4000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//       >
//         <Alert
//           onClose={handleSnackbarClose}
//           severity="success"
//           sx={{ width: "100%" }}
//         >
//           {snackbarMsg}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// }

import React, { useEffect, useMemo, useState } from "react";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useAuth } from "../App";
import {
  fetchCandidateScheduleContext,
  searchCandidates,
} from "../api";

const EVENT_TYPES = [
  { value: "interview", label: "Interview" },
  { value: "call", label: "Call" },
  { value: "meeting", label: "Meeting" },
  { value: "other", label: "Other" },
];

const EMPTY_FORM = {
  summary: "",
  description: "",
  start: "",
  end: "",
  event_type: "interview",
  application_id: "",
  attendees: "",
  notes: "",
  attachment: "",
};

function splitEmails(value) {
  return value
    .split(",")
    .map((email) => email.trim())
    .filter(Boolean);
}

function uniqueEmails(emails) {
  return [...new Set(emails.filter(Boolean))];
}

function toApiDateTime(value) {
  if (!value) return "";
  return new Date(value).toISOString();
}

export default function EventScheduleModalV2({
  open,
  onClose,
  onSubmit,
  recruiterEmail = "",
}) {
  const { fetchWithAuth } = useAuth();

  const [form, setForm] = useState(EMPTY_FORM);
  const [selectedCandidate, setSelectedCandidate] = useState(null);

  const [candidateQuery, setCandidateQuery] = useState("");
  const [candidateOptions, setCandidateOptions] = useState([]);
  const [candidatesLoading, setCandidatesLoading] = useState(false);

  const [scheduleContext, setScheduleContext] = useState([]);
  const [contextLoading, setContextLoading] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const selectedApplication = useMemo(() => {
    return (
      scheduleContext.find(
        (item) => item.application_id === form.application_id
      ) || null
    );
  }, [scheduleContext, form.application_id]);

  useEffect(() => {
    if (!open) return;

    setForm(EMPTY_FORM);
    setSelectedCandidate(null);
    setCandidateQuery("");
    setCandidateOptions([]);
    setScheduleContext([]);
    setError("");
    setSubmitting(false);
  }, [open]);

  useEffect(() => {
    if (!open) return;

    let cancelled = false;

    const timer = setTimeout(async () => {
      setCandidatesLoading(true);

      try {
        const result = await searchCandidates(fetchWithAuth, {
          search: candidateQuery,
          page: 1,
          limit: 20,
        });

        if (!cancelled) {
          setCandidateOptions(Array.isArray(result.data) ? result.data : []);
        }
      } catch (err) {
        if (!cancelled) {
          setCandidateOptions([]);
        }
      } finally {
        if (!cancelled) {
          setCandidatesLoading(false);
        }
      }
    }, 300);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [open, candidateQuery, fetchWithAuth]);

  useEffect(() => {
    if (!open || !selectedCandidate?.id) {
      setScheduleContext([]);
      setForm((current) => ({ ...current, application_id: "" }));
      return;
    }

    let cancelled = false;

    async function loadScheduleContext() {
      setContextLoading(true);
      setError("");

      try {
        const data = await fetchCandidateScheduleContext(
          fetchWithAuth,
          selectedCandidate.id
        );

        if (!cancelled) {
          setScheduleContext(Array.isArray(data) ? data : []);

          if (Array.isArray(data) && data.length === 1) {
            setForm((current) => ({
              ...current,
              application_id: data[0].application_id,
            }));
          } else {
            setForm((current) => ({
              ...current,
              application_id: "",
            }));
          }
        }
      } catch (err) {
        if (!cancelled) {
          setScheduleContext([]);
          setError(err.message || "Failed to load candidate applications.");
        }
      } finally {
        if (!cancelled) {
          setContextLoading(false);
        }
      }
    }

    loadScheduleContext();

    return () => {
      cancelled = true;
    };
  }, [open, selectedCandidate, fetchWithAuth]);

  const updateForm = (field) => (event) => {
    setForm((current) => ({
      ...current,
      [field]: event.target.value,
    }));
  };

  const validate = () => {
    if (!selectedCandidate) return "Please select a candidate.";
    if (!form.application_id) return "Please select a related application/job.";
    if (!form.summary.trim()) return "Please enter a summary.";
    if (!form.start) return "Please select a start time.";
    if (!form.end) return "Please select an end time.";

    const startDate = new Date(form.start);
    const endDate = new Date(form.end);

    if (Number.isNaN(startDate.getTime())) return "Invalid start time.";
    if (Number.isNaN(endDate.getTime())) return "Invalid end time.";
    if (startDate >= endDate) return "Start time must be before end time.";

    return "";
  };

  const handleSubmit = async () => {
    const validationError = validate();

    if (validationError) {
      setError(validationError);
      return;
    }

    const extraAttendees = splitEmails(form.attendees);

    const attendees = uniqueEmails([
      selectedCandidate?.email,
      recruiterEmail,
      ...extraAttendees,
    ]);

    const payload = {
      summary: form.summary.trim(),
      description: form.description.trim() || null,
      start: toApiDateTime(form.start),
      end: toApiDateTime(form.end),
      attendees,
      event_type: form.event_type,
      notes: form.notes.trim() || null,
      attachment: form.attachment.trim() || null,
      application_id: selectedApplication.application_id,
      job_order_id: selectedApplication.job_order_id,
    };

    setSubmitting(true);
    setError("");

    try {
      await onSubmit(payload);
      onClose();
    } catch (err) {
      setError(err.message || "Failed to schedule event.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 24px 60px rgba(15,23,42,0.30)",
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" fontWeight={700}>
          Schedule Event
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Schedule an interview, call, meeting, or follow-up with a candidate.
        </Typography>
      </DialogTitle>

      <DialogContent dividers sx={{ pt: 2.5, pb: 2.5 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Grid container spacing={2.5}>
          <Grid item xs={12} md={6}>
            <Autocomplete
              fullWidth
              options={candidateOptions}
              loading={candidatesLoading}
              value={selectedCandidate}
              onChange={(event, value) => {
                setSelectedCandidate(value);
                setScheduleContext([]);
                setForm((current) => ({
                  ...current,
                  application_id: "",
                }));
              }}
              onInputChange={(event, value, reason) => {
                if (reason === "input") {
                  setCandidateQuery(value);
                }
              }}
              getOptionLabel={(option) => {
                if (!option) return "";
                return `${option.full_name || "Unnamed candidate"}${
                  option.email ? ` (${option.email})` : ""
                }`;
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              filterOptions={(options) => options}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Candidate"
                  required
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                        {params.InputProps.startAdornment}
                      </>
                    ),
                    endAdornment: (
                      <>
                        {candidatesLoading ? (
                          <CircularProgress color="inherit" size={18} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
              noOptionsText={
                candidateQuery
                  ? "No candidates found"
                  : "Search for a candidate"
              }
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              select
              fullWidth
              required
              label="Related Application / Job"
              value={form.application_id}
              onChange={updateForm("application_id")}
              disabled={!selectedCandidate || contextLoading}
              helperText={
                selectedCandidate && !contextLoading && scheduleContext.length === 0
                  ? "No applications found for this candidate."
                  : ""
              }
            >
              {contextLoading ? (
                <MenuItem value="">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CircularProgress size={16} />
                    Loading applications...
                  </Box>
                </MenuItem>
              ) : (
                scheduleContext.map((item) => (
                  <MenuItem
                    key={item.application_id}
                    value={item.application_id}
                  >
                    {item.job_title}
                    {item.company_name ? ` · ${item.company_name}` : ""}
                    {item.application_status
                      ? ` · ${item.application_status}`
                      : ""}
                  </MenuItem>
                ))
              )}
            </TextField>
          </Grid>

          <Grid item xs={12} md={8}>
            <TextField
              fullWidth
              required
              label="Summary"
              value={form.summary}
              onChange={updateForm("summary")}
              placeholder="e.g. First-round interview"
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              select
              fullWidth
              label="Event Type"
              value={form.event_type}
              onChange={updateForm("event_type")}
            >
              {EVENT_TYPES.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              required
              label="Start Time"
              type="datetime-local"
              value={form.start}
              onChange={updateForm("start")}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              required
              label="End Time"
              type="datetime-local"
              value={form.end}
              onChange={updateForm("end")}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Additional Attendees"
              value={form.attendees}
              onChange={updateForm("attendees")}
              helperText="Optional. Separate emails with commas. The selected candidate is included automatically."
              placeholder="panelist@example.com, recruiter@example.com"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              minRows={2}
              label="Description"
              value={form.description}
              onChange={updateForm("description")}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Attachment URL"
              value={form.attachment}
              onChange={updateForm("attachment")}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Internal Notes"
              value={form.notes}
              onChange={updateForm("notes")}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} color="inherit" disabled={submitting}>
          Cancel
        </Button>

        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={submitting || candidatesLoading || contextLoading}
          startIcon={
            submitting ? <CircularProgress color="inherit" size={18} /> : null
          }
        >
          {submitting ? "Scheduling..." : "Schedule Event"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}